<template>
    <div class="main-container">
        <!-- Navbar section -->
        <Navbar/>

        <!-- hero section -->
        <GenericHero :title="$t('sentiment_api.title')" :subtitle="$t('sentiment_api.subtitle')" :image="require('../../assets/img/trustami/sentiment_blog.svg')" />

        <ContentSection>
            <template #header>{{ $t("sentiment_api.section_1") }}</template>
            <template #main>
                <p>{{ $t("sentiment_api.section_1_1") }}</p>
                <p>{{ $t("sentiment_api.section_1_2") }}</p>
                <p class="tweet">{{ $t("sentiment_api.section_1_3") }}</p>
                <p>{{ $t("sentiment_api.section_1_4") }}</p>
                <p>{{ $t("sentiment_api.section_1_5") }}</p>
            </template>
        </ContentSection>

        <ContentSection>
            <template #header>{{ $t("sentiment_api.section_2") }}</template>
            <template #main>
                <p>{{ $t("sentiment_api.section_2_1") }}</p>
                <p>{{ $t("sentiment_api.section_2_2") }}</p>
            </template>
        </ContentSection>

        <ContentSection>
            <template #header>{{ $t("sentiment_api.section_3") }}</template>
            <template #main>
                <p>{{ $t("sentiment_api.section_3_1") }}</p>

                <h4>{{ $t("sentiment_api.section_3_2") }}</h4>
                <p>{{ $t("sentiment_api.section_3_3") }}</p>

                <h4>{{ $t("sentiment_api.section_3_4") }}</h4>
                <p>{{ $t("sentiment_api.section_3_5") }}</p>

                <h4>{{ $t("sentiment_api.section_3_6") }}</h4>
                <p>{{ $t("sentiment_api.section_3_7") }}</p>

                <h4>{{ $t("sentiment_api.section_3_8") }}</h4>
                <p>{{ $t("sentiment_api.section_3_9") }}</p>
            </template>
        </ContentSection>

        <ContentSection>
            <template #header>{{ $t("sentiment_api.section_4") }}</template>
            <template #main>
                <p>{{ $t("sentiment_api.section_4_1") }}</p>
                <p>{{ $t("sentiment_api.section_4_2") }}</p>
                <p>{{ $t("sentiment_api.section_4_3") }}</p>
                <p>{{ $t("sentiment_api.section_4_4") }}</p>
            </template>
        </ContentSection>

        <ContentSection>
            <template #header>{{ $t("sentiment_api.section_5") }}</template>
            <template #main>
                <p>{{ $t("sentiment_api.section_5_1") }}</p>
                <p>{{ $t("sentiment_api.section_5_2") }}</p>
            </template>
        </ContentSection>

        <ContentSection>
            <template #header>{{ $t("sentiment_api.section_6") }}</template>
            <template #main>
                <p>{{ $t("sentiment_api.section_6_1") }}</p>
                <p>{{ $t("sentiment_api.section_6_2") }}</p>
                <p v-html="$t('sentiment_api.section_6_3')"></p>
            </template>
        </ContentSection>

        <ContentSection>
            <template #main>
                <p v-html="$t('sentiment_api.section_footer')"></p>
            </template>
        </ContentSection>

        <!-- footer section -->
        <FooterMain/>

    </div>
</template>

<style>
.tweet {
    padding: 12px 20px;
    background: #1D9BF0;
    color: #fff;
    border-radius: 2px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
    font-style: italic;
}
</style>

<script>
import GenericHero from '../../comp_trustami/GenericHero';
import ContentSection from '../../comp_trustami/Research/ContentSection';
import FooterMain from '../../comp_trustami/FooterMain';
import Navbar from "../../comp_trustami/NavbarSub";

export default {
    name: 'app',
    components: {
        Navbar,
        GenericHero,
        ContentSection,
        FooterMain,
    },

    metaInfo: {
        title: 'Sentiment Analysis - Trustami.AI Web Services',
        meta: [
            {
                name: 'description',
                content: 'No more guessing if your partner is angry! Battle-tested polarity classification for German texts. Sentiment intensity included.'
            }
        ],
        htmlAttrs: {
            lang: 'en',
            amp: true
        }
    }
}
</script>
